import { useRouter } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Icon-only back button that returns to the previous page in browser history. */
export function BackButton({ label }: { label?: string } = {}) {
  const router = useRouter();

  if (label) {
    return (
      <Button variant="outline" size="sm" onClick={() => router.history.back()}>
        <ArrowLeft className="mr-1 h-4 w-4" />
        {label}
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => router.history.back()}
      aria-label="Go back"
    >
      <ArrowLeft className="h-4 w-4" />
    </Button>
  );
}
